import { json, type LoaderFunctionArgs } from '@remix-run/node';
import type { ShouldRevalidateFunction } from '@remix-run/react';
import { z } from 'zod';
import { ModerationEntityTypeEnum } from 'generated/graphql';
import { getModerationReasons } from '~/modules/moderation/api/get-moderation-reasons.server';

export const MODERATION_REASONS_API_ROUTE = '/remix-api/moderation/reasons';

const QUERY_SCHEMA = z.object({
    entityType: z.nativeEnum(ModerationEntityTypeEnum),
});

/**
 * API endpoint to get moderation reasons.
 * Use with the `useUserModeration` hook.
 * @see {@link packages/web/app/modules/moderation/hooks/use-user-moderation.ts}
 */
export const loader = async ({ context, request }: LoaderFunctionArgs) => {
    const { logger } = context;
    const url = new URL(request.url);
    const result = QUERY_SCHEMA.safeParse({
        entityType: url.searchParams.get('entityType'),
    });

    if (!result.success) {
        return json(null, { status: 400 });
    }

    try {
        const moderationReasons = await getModerationReasons({
            context,
            entityType: result.data.entityType,
        });

        if (!moderationReasons) {
            return json(null, { status: 500 });
        }

        return json({ moderationReasons });
    } catch (error) {
        logger.error(`Error in ${MODERATION_REASONS_API_ROUTE}`, { error });
        return json(null, { status: 500 });
    }
};

export const shouldRevalidate: ShouldRevalidateFunction = () => {
    return false;
};
